import { Empty, Typography } from "antd";
import { showError } from "common/ToastNotifications";
import { FullHeightContainerLayout, LoadingOverlay, SystemConnectionAwsS3HistoryList } from "components";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Title, Text } = Typography;

class EventSystemConnection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingData: true,
        };
    }

    componentWillMount() {
        if (!this.props.itemOperation) {
            this.setState({
                busy: true,
                busyMessage: "Getting connection...",
            });
            this.props.getEventSystemConnection(this.props.eventId, this.props.connectionId);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetEventConnectionResultUpdate(prevProps);
    }

    onGetEventConnectionResultUpdate = (prevProps) => {
        if (this.props.getEventConnectionResult && this.props.getEventConnectionResult !== prevProps.getEventConnectionResult) {
            if (!this.props.getEventConnectionResult.success) {
                if (this.props.getEventConnectionResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to get connection at this moment.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingData: false,
            });
        }
    };

    isBusy = () => {
        let isBusy = this.state.busy || this.state.fetchingData;
        return isBusy;
    };

    getSystemConnectionComponent = () => {
        const connectionType = this.props.connectionRevision?.data?.type;

        if (!connectionType) {
            return <Empty description="No system connection revision data available" />;
        }

        switch (connectionType) {
            case "aws_s3":
                return <SystemConnectionAwsS3HistoryList connectionRevisions={[this.props.connectionRevision]}></SystemConnectionAwsS3HistoryList>;
            default:
                return <></>;
        }
    };

    render() {
        return (
            <>
                {this.isBusy() ? <LoadingOverlay busy={true} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay> : <></>}
                {!this.state.fetchingData ? (
                    <FullHeightContainerLayout
                        showHeader={true}
                        showFooter={false}
                        header={
                            <Title level={5}>
                                <Text>Event Revision - </Text>
                                <Text type="secondary" italic>{`(Connection: ${this.props.connectionName})`}</Text>
                            </Title>
                        }
                        content={this.props.connectionRevision ? this.getSystemConnectionComponent() : <Empty></Empty>}
                    ></FullHeightContainerLayout>
                ) : (
                    <></>
                )}
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getEventConnectionResult: state.eventSystemConnection.getEventConnectionResult,
        connectionRevision: state.eventSystemConnection.connectionRevision,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEventSystemConnection: (eventId, connectionId) => dispatch(actions.getEventSystemConnectionRequest(eventId, connectionId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventSystemConnection));
